<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">News Category</h3>
              <router-link :to="{ path: 'news-category/create' }" class="float-right mt-0">
                <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add News Category</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title :class="$vuetify.breakpoint.mdAndUp ? 'col-4 float-right' : 'col-12'">
                <v-text-field
                  class="search-text-field"
                  v-model="search"
                  append-icon="search"
                  label="Search by Name"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="float-left width-100"
                :headers="headers"
                :items="newsCategoty"
                :search="search"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.parentCat`]="{ item }">
                  {{
                  item.parentCat ? item.parentCat : "-"
                  }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <!-- <div v-if="predefinedCategoryList.includes(item.name)" class="pl-5">
                    <v-tooltip bottom max-width="250" color="warning">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mdi mdi-information-outline"
                          v-bind="attrs"
                          v-on="on"
                        ></v-icon>
                      </template>
                      <span>Predefined category. So you cannot delete the category.</span>
                    </v-tooltip>
                  </div> -->
                  <div>
                  <router-link :to="{ path: 'news-category/' + item._id }">
                    <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                      <template v-slot:activator="{ on: tooltip, attrs }">
                      <img
                        v-bind="attrs"
                        v-on="{ ...tooltip }"
                        class="mr-2 edit-icon"
                        src="@/assets/images/Edit.svg" />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>
                  <delete-component
                    v-if="!predefinedCategoryList.includes(item.slug)"
                    :id="item._id"
                    module="newsCategory/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                  </div>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2 float-left width-100">
                <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { NewscategoryService } from "@/services";
import DeleteComponent from "@/components/DeleteComponent";

export default {
  name: "NewsCategory",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: "",
    newsCategoty: [],
    active: [],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "name",
      },
      { text: "Parent Category", value: "parentCat" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    predefinedCategoryList:['WEBINARS','JOURNAL_CLUB', 'KEY_PUBLICATIONS']
  }),
  watch: {
    selected: "",
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const categoryList = await NewscategoryService.getCategoryList();
      const flatArry = [];
      for (let i = 0; i < categoryList.data.length; i += 1) {
        flatArry.push(categoryList.data[i]);
        if (categoryList.data[i].childs && categoryList.data[i].childs.length) {
          for (let j = 0; j < categoryList.data[i].childs.length; j += 1) {
            categoryList.data[i].childs[j].parentCat =
              categoryList.data[i].name;
            flatArry.push(categoryList.data[i].childs[j]);
          }
        }
      }
      this.newsCategoty = flatArry;
      this.pageCount = Math.ceil(this.newsCategoty.length / this.itemsPerPage);
      this.loading = false;
    },
    async handleClick(value) {
      this.$router.push("/news-category/" + value._id);
    },
    requestDeleted() {
      this.initialize();
    },
  },
};
</script>
